import script from "./base-signature.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-signature.vue?vue&type=script&setup=true&lang=ts"

import "./base-signature.vue?vue&type=style&index=0&id=3ce555da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce555da"]])

export default __exports__